var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Forward_arrow_22px",
    "data-name": "Forward arrow_22px",
    transform: "translate(-373 -265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1215",
    "data-name": "Rectangle 1215",
    width: 22,
    height: 22,
    transform: "translate(373 265)",
    fill: "#ffefdc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1216",
    "data-name": "Rectangle 1216",
    width: 16,
    height: 16,
    transform: "translate(376 268)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "chevrons-right_1_",
    "data-name": "chevrons-right (1)",
    transform: "translate(376.997 270.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M13,18.672l5.836-5.836L13,7",
    transform: "translate(-4.83 -7)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M6,18.672l5.836-5.836L6,7",
    transform: "translate(-6 -7)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowWhiteIcon);
export default __webpack_public_path__ + "static/media/double-arrow-white-icon.7da76783409c044d8a9ac9c9b8551796.svg";
export { ForwardRef as ReactComponent };